export default __webpack_public_path__ + "static/media/1 - Kodiak Cathedral.0d792dfd.jpeg";